// OneDrive:IgnoreCodeCoverage

import { createSingleEvent, ISingleEventType, ISingleEvent } from '../SingleEventBase';
import { EventFieldType } from '../IEvent';
export interface ITraceSingleSchema {
    /**
     * This is the trace message
     */
    message: string;
}

export interface ITrace extends ISingleEvent<ITraceSingleSchema> {
    data: ITraceSingleSchema;
}

export type Trace = ITrace;

export const Trace: ITraceType = createSingleEvent<ITraceSingleSchema>({
    eventName: 'Trace,',
    shortEventName: 'Trace',
    requiresParent: false
}, {
        message: EventFieldType.String
    });

export interface ITraceType extends ISingleEventType<ITraceSingleSchema> {
}
